import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemAttributeListValueModel extends IModel {
  salesItemAttributeListValueId: number;
  salesItemAttributeId: number;
  name: string;
  storage: string;
  sortOrder: number;
  storageUI: any; //UI Field Only
  isExpired: boolean; //UI Field Only
  userUpdated: string;
  lotNumber: string; //UI Field Only
  serialNumber: string; //UI Field Only
}

export class SalesItemAttributeListValueModel
  extends Model
  implements ModelRecord<ISalesItemAttributeListValueModel>
{
  salesItemAttributeListValueId: number;
  salesItemAttributeId: number;
  name: string;
  storage: string;
  sortOrder: number;
  storageUI: any; //UI Field Only
  isExpired: boolean; //UI Field Only
  userUpdated: string;
  lotNumber: string; //UI Field Only
  serialNumber: string; //UI Field Only

  constructor(params?: Partial<ISalesItemAttributeListValueModel>) {
    super(params);
    this.salesItemAttributeListValueId = _.defaultTo(
      params?.salesItemAttributeListValueId,
      0,
    );
    this.salesItemAttributeId = _.defaultTo(params?.salesItemAttributeId, 0);
    this.name = _.defaultTo(params?.name, '');
    this.storage = _.defaultTo(params?.storage, '{}');
    this.sortOrder = _.defaultTo(params?.sortOrder, 0);
    this.userUpdated = _.defaultTo(params?.userUpdated, '');
    try {
      this.storageUI = JSON.parse(this.storage);
    } catch (e) {
      this.storageUI = {};
      this.storage = '{}';
    }
    this.isExpired = _.defaultTo(
      new Date(this.storageUI?.expirationDate) < new Date(),
      false,
    );
    this.lotNumber = _.defaultTo(
      this.storageUI?.serialNumber?.split('/')[0],
      '',
    );
    this.serialNumber =
      this.storageUI?.serialNumber?.split('/').length > 1
        ? _.defaultTo(this.storageUI?.serialNumber?.split('/')[1], '')
        : '';
  }
}
